module.exports = __webpack_public_path__ + "img/parthner-9.088d01aa.svg";